<template>
  <div class="store-list">
    <div v-for="(store, index) in markers" :key="store.infoText.address" v-bind:index="index" class="store">
      <div class="store-info">
        <h2>{{store.infoText.name}}</h2>
        <p>{{store.infoText.address}}</p>
        <p>{{store.infoText.city}}, {{store.infoText.state}} {{store.infoText.zip}}</p>
        <p>{{store.infoText.phone}}</p>
      </div>
      <div class="store-directions">
        <p v-if="store.distance">{{Math.ceil(store.distance * 0.000621371192)}} miles away</p>
        <a :href="`https://maps.google.com/maps?daddr=${store.infoText.address} ${store.infoText.city}, ${store.infoText.state} ${store.infoText.zip}`"><i class="fas fa-car"></i></a>
        <br>
        <b-button pill variant="success" @click="updateVendorName(index)" @mouseover="reviewName(index)">Select</b-button>
      </div>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreList',
  props: {
    markers: Array,
    store:{}
  },
  data(){
    return{
      selectedServiceCenter:'',
      serviceCenterId:''
    }
  },

  methods:{
    reviewName(index){
      this.selectedServiceCenter = this.markers[index].infoText.name
      this.serviceCenterId = this.markers[index].infoText.id
      this.$store.state.userData.selectedVendor = this.serviceCenterId
      localStorage.setItem('vendor', this.serviceCenterId)
    },
    updateVendorName(index){
      this.serviceCenterId = this.markers[index].infoText.id
      this.$store.state.userData.selectedVendor = this.serviceCenterId
      localStorage.setItem('vendor', this.serviceCenterId)
      this.$router.push({
        name: 'UserCreate',
      })
    },
  }
}
</script>

<style scoped>
h2{

  color: #009579;

}

.btn{
  background-color: #F15B22 !important;
}

.btn:hover{
  background-color: green !important;
}
.store-list {
  border: 1px solid #eee;
  height: 500px;
  overflow-y: scroll;
}
.store {
  padding: 10px;
}
.store p {
  margin-bottom: 5px;
}
.store-info,
.store-directions {
  text-align: center;
}
.store-directions i {
  font-size: 65px;
  color: #1C61B2;
}
</style>



// WEBPACK FOOTER //
// src/components/StoreList.vue